module.exports = __webpack_public_path__ + "static/media/35-2.177d4a61.mp3";